import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance } from 'vue'
import { getBrandListApi } from '@/apis/electron'
interface ListM {
    id:     number,     // ID
    name:   string,     // 名称
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectElectronBrands',
  props: {
    classNames: {   // 类名
        type: Array,
        default: ['filter-item']
    },
    filterable: {   // 是否可筛选
        type: Boolean,
        default: true
    },
    clearable: {    // 是否可一键清除
        type: Boolean,
        default: true
    },
    multiple: {     // 是否可多选
        type: Boolean,
        default: false
    },
},
  emits: ['brandChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const proxy = getCurrentInstance() as any
const emits = __emit
const props = __props
const brandProps = {
    value: 'id',
    label: 'name'
}
const selectedId = ref(undefined)
const list = ref<ListM[]>([])
const onGetList = async () => {
    const {code, data, msg} = await getBrandListApi({page_size:1000}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    list.value = data
}
onGetList()

// 品牌变化，通过父组件
const onSelectedChange = () => {
    emits('brandChange', selectedId.value)
}
// 清空数据
const clear = () => {
    selectedId.value = ''
}
__expose({
    clear
})

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!

  return (_openBlock(), _createBlock(_component_el_select_v2, {
    class: _normalizeClass(__props.classNames),
    modelValue: selectedId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedId).value = $event)),
    filterable: __props.filterable,
    clearable: __props.clearable,
    multiple: __props.multiple,
    placeholder: "请选择品牌",
    props: brandProps,
    options: list.value,
    onChange: onSelectedChange
  }, null, 8, ["class", "modelValue", "filterable", "clearable", "multiple", "options"]))
}
}

})